const remove = [/<(?!\/?mark>)[^>]*>?/gm, /\u00AD/g, "&lt;", "&gt;"] as const;

const replace = [
  ["&quot;", '"'],
  ["&apos;", "'"],
  ["&amp;", "&"],
  ["&agrave;", "à"],
  ["&aacute;", "á"],
  ["&acirc;", "â"],
  ["&atilde;", "ã"],
  ["&auml;", "ä"],
  ["&aring;", "å"],
  ["&aelig;", "æ"],
  ["&ccedil;", "ç"],
  ["&egrave;", "è"],
  ["&eacute;", "é"],
  ["&ecirc;", "ê"],
  ["&euml;", "ë"],
  ["&igrave;", "ì"],
  ["&iacute;", "í"],
  ["&icirc;", "î"],
  ["&iuml;", "ï"],
  ["&ntilde;", "ñ"],
  ["&ograve;", "ò"],
  ["&oacute;", "ó"],
  ["&ocirc;", "ô"],
  ["&otilde;", "õ"],
  ["&ouml;", "ö"],
  ["&oslash;", "ø"],
  ["&ugrave;", "ù"],
  ["&uacute;", "ú"],
  ["&ucirc;", "û"],
  ["&uuml;", "ü"],
  ["&yacute;", "ý"],
  ["&yuml;", "ÿ"],
  ["&Agrave;", "À"],
  ["&Aacute;", "Á"],
  ["&Acirc;", "Â"],
  ["&Atilde;", "Ã"],
  ["&Auml;", "Ä"],
  ["&Aring;", "Å"],
  ["&AElig;", "Æ"],
  ["&Ccedil;", "Ç"],
  ["&Egrave;", "È"],
  ["&Eacute;", "É"],
  ["&Ecirc;", "Ê"],
  ["&Euml;", "Ë"],
  ["&Igrave;", "Ì"],
  ["&Iacute;", "Í"],
  ["&Icirc;", "Î"],
  ["&Iuml;", "Ï"],
  ["&Ntilde;", "Ñ"],
  ["&Ograve;", "Ò"],
  ["&Oacute;", "Ó"],
  ["&Ocirc;", "Ô"],
  ["&Otilde;", "Õ"],
  ["&Ouml;", "Ö"],
  ["&Oslash;", "Ø"],
  ["&Ugrave;", "Ù"],
  ["&Uacute;", "Ú"],
  ["&Ucirc;", "Û"],
  ["&Uuml;", "Ü"],
  ["&Yacute;", "Ý"],
  ["&nbsp;", " "],
  ["&ndash;", "–"],
  ["&mdash;", "—"],
  ["&lsquo;", "\u2018"],
  ["&rsquo;", "\u2019"],
  ["&ldquo;", "\u201C"],
  ["&rdquo;", "\u201D"],
  ["&bull;", "•"],
  ["&hellip;", "…"],
  ["&euro;", "€"],
  ["&pound;", "£"],
  ["&yen;", "¥"],
  ["&copy;", "©"],
  ["&reg;", "®"],
] as const;

export function stripHtml(html: string): string {
  let result = html;

  // Protect the mark tags returned from highlighted search results
  result = result
    .replaceAll("<mark>", "[mark]")
    .replaceAll("</mark>", "[/mark]");

  for (const rm of remove) {
    result = result.replaceAll(rm, "");
  }

  for (const [key, value] of replace) {
    result = result.replaceAll(key, value);
  }

  // Return the mark tags to original state
  result = result
    .replaceAll("[mark]", "<mark>")
    .replaceAll("[/mark]", "</mark>");

  return result;
}
